<template>
  <a-flex justify="space-between" align="center" style="width: 100%">
    <a-flex align="center" gap="small">
      <div class="logo">
        <a-avatar src="/img/logo.svg" shape="square" size="large"/>
        <a-flex align="center" gap="28">
          <a-typography-text>管店宝拓客</a-typography-text>
        </a-flex>
      </div>
      <a-divider type="vertical"/>
      <a-typography-text strong style="font-size: 16px">活动编辑器</a-typography-text>
    </a-flex>

    <a-flex justify="center">
      <a-select style="width: 100%; min-width: 300px" size="large" not-found-content="暂无可选的品牌/分支"
                :options="branches" v-model:value="editor.active.preview.branch_id" @change="editor.refresh()"/>
    </a-flex>

    <a-flex style="padding-right: 16px" gap="middle">
      <a-button danger size="large" :icon="h(LogoutOutlined)" @click="$router.push('/activities')"
                :loading="editor.active.status.loading">
        退出编辑
      </a-button>
      <a-button v-if="!editor.meta.publish_at && editor.meta.activity_id" size="large" :icon="h(SaveOutlined)"
                type="default"
                :loading="editor.active.status.loading" @click="editor.save()">
        {{ editor.active.status.lastSaveTS }} 保存活动
      </a-button>
      <a-button v-if="!editor.meta.publish_at" size="large" :icon="h(SendOutlined)" type="primary"
                :loading="editor.active.status.loading" @click="editor.publish()">发布活动
      </a-button>
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">

import {computed, h} from "vue"
import {useRoute} from "vue-router";
import {LogoutOutlined, SaveOutlined, SendOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/model/editor";

const editor = useRoute().meta.editor as AEditor;

const branches = computed(() => {
  const arr = [] as unknown[]
  editor.meta.branch_ids.forEach((branch_id: string) => {
    editor.userAgent.active.brands.forEach(b => {
      const br = b.branches.find(i => i.branch_id === branch_id)
      if (br) arr.push({label: b.name + br.name, value: br.branch_id})
    })
  })
  return arr
})

</script>

<style scoped lang="sass">
@import "@/main.variable"

.logo
  display: flex
  align-items: center
  justify-content: space-evenly
  width: 160px
  margin-left: 8px

  > .ant-flex
    > span

      &:first-child
        font-size: 20px
        position: relative

.tab-bar-menu
  flex: 1 1 auto
  display: flex
  position: relative
  align-items: center
  padding-left: 34px

  > a
    text-decoration: none
    margin-right: 43px
    border: 1px solid rgba(220, 223, 230, .56)
    border-radius: 20px
    height: 36px
    cursor: pointer
    display: flex
    justify-content: center
    align-items: center
    padding: 0 22px 0 16px

    &.active > span
      color: $color-primary

    > span
      padding-left: 6px
      line-height: 22px
      font-weight: 700
      font-size: 16px
      color: #0e1234

.menu-right-account-sub-title
  margin: 28px 18px
  min-width: 240px

.menu-right
  line-height: 70px
  flex: 1 1 auto
  justify-content: right

  .menu-right-account-item
    line-height: 20px
    font-size: 14px
    color: rgba(0, 0, 0, 0.6)


  :deep(.ant-menu-item:not(.ant-menu-item-selected):hover)
    background-color: rgba(0, 0, 0, 0.05)
    color: $color-primary !important


  :deep(.ant-menu-item::after)
    border: none

  :deep(.ant-menu-submenu::after)
    border: none

</style>